export const createTempInputElementForUploadingFile = (accept = '.csv', callback = () => {
}) => {
  const inputEl = document.createElement('input');
  inputEl.type = 'file';
  inputEl.accept = accept;
  inputEl.addEventListener('change', callback);
  document.body.appendChild(inputEl);
  inputEl.click();
  document.body.removeChild(inputEl);
}